<template>
    <div class="dv-feedback-tool-wrapper">
        <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
                Don't like the default view? suggest a better one <span @click="showFeedbackTool = !showFeedbackTool" class="text-primary pointer" type="button">here</span> 
            </small>
        </div>

        <div v-if="showFeedbackTool" class="dv-feedback-tool-wrapper">
            <form v-if="showFeedbackForm" action="" class="feedback-tool-form" @submit.prevent>
                <span>Suggest a default View Option (Numerical, Categorical or Table View): </span>
                <dv-select-header class="py-3" title="View Option" :defaultLabel="selectedView" :labels="navOptions"  @updatePicked="(label) => {selectedView = label}"></dv-select-header>

                <div v-if="selectedView == 'Numerical View'" class="dv-feedback-form-numerical">
                    <span>Suggest a Chart type and/or Labels and Values to be set as default: </span>
    
                    <div class="d-flex dv-fb-options py-3 flex-wrap">
                        <dv-select-header class="mr-2 mb-2" title="Chart type" :defaultLabel="suggestedChartType || defaultSuggestedChartType" :labels="allChartOptions"  @updatePicked="(label) => suggestedChartType = label.toUpperCase()"></dv-select-header>
                        <dv-select-header class="mr-2 mb-2" title="Labels" :defaultLabel="suggestedX || defaultSuggestedX" :labels="allLabels" @updatePicked="(label) => suggestedX = label"></dv-select-header>
                        <dv-select-header class="mr-2 mb-2" v-if="suggestedY.length > 0 && suggestedY[0] !== undefined" title="Values" :defaultLabel="suggestedY" :labels="numericalLabels" :multi-select="true" @updatePicked="(label) => suggestedY.includes(label) ? suggestedY.splice(suggestedY.indexOf(label), 1) : suggestedY.push(label)"></dv-select-header>
                    </div>
                </div>

                <div v-if="selectedView == 'Categorical View'" class="dv-feedback-form-categorical">
                    <span>Suggest a Chart type and/or Labels to be set as default: </span>
    
                    <div class="d-flex dv-fb-options py-3">
                        <dv-select-header title="Chart type" :defaultLabel="suggestedChartType || defaultSuggestedChartType" :labels="allChartOptions"  @updatePicked="(label) => {suggestedChartType = label.toUpperCase()}"></dv-select-header>
                        <dv-select-header title="Labels" :defaultLabel="suggestedCategoricalLabel || categoricalLabels[0]" :labels="categoricalLabels" @updatePicked="(label) => {suggestedCategoricalLabel = label}"></dv-select-header>
                    </div>
                </div>
                
                <br>
                <input @click="showFeedbackTool = false" class="btn btn-outline-dark mr-2 mb-1" type="button" value="Cancel">
                <input @click="submitFeedbackInput" class="btn btn-primary mb-1" type="button" value="Submit">
            </form>
            <div v-else class="text-center m-5">
                Thank you for your feedback!
            </div>
        </div>
    </div> 
</template>

<script setup>
    import DvSelectHeader from './DvSelectHeader.vue';
    import { ref, watch } from 'vue';
    import axios from 'axios';
    import { getCurrentInstance } from 'vue';
    
    const props = defineProps({
        downloadUrl: String,
        allChartOptions: Array,
        allLabels: Array,
        numericalLabels: Array,
        categoricalLabels: Array,
        defaultSuggestedChartType: String,
        defaultSuggestedX: String,
        defaultSuggestedY: Array,
    });

    const instance = getCurrentInstance(); 
    const visualisationServiceUrl = instance?.appContext.config.globalProperties.$env.content.datasetDetails.distributions.visualisationServiceUrl;

    const navOptions = ["Numerical View", "Categorical View", "Table View"]
    const selectedView = ref('Numerical View')
    const showFeedbackTool = ref(false)
    const showFeedbackForm = ref(true)
    const suggestedChartType = ref('')
    const suggestedX = ref('')
    const suggestedY = ref([])
    const suggestedCategoricalLabel = ref([])
    const feedbackReport = ref({})
    
    watch(
        () => ({
            y: props.defaultSuggestedY,
            x: props.defaultSuggestedX,
            chartType: props.defaultSuggestedChartType
        }),
        ({ y, x, chartType }) => {
            if (y !== undefined && y !== null) suggestedY.value = [...y];
            if (x !== undefined && x !== null) suggestedX.value = x;
            if (chartType !== undefined && chartType !== null) suggestedChartType.value = chartType.toUpperCase();
        },
        { immediate: true }
    );

    const submitFeedbackInput = () => {
        feedbackReport.value = {
            "distributionUrl": props.downloadUrl,
            "defaultView": viewType(selectedView.value),  // TABLE / NUMERICAL / CATEGORICAL
            "defaultChart": viewType(selectedView.value) == 'TABLE' ? '' : suggestedChartType.value,
            "defaultLabel": viewType(selectedView.value) == 'TABLE' ? '' : (viewType(selectedView.value) == 'NUMERICAL' ? suggestedX.value  : suggestedCategoricalLabel.value),
            "defaultValues": viewType(selectedView.value) == 'NUMERICAL' ? suggestedY.value : [],
        }

        axios.post(`${visualisationServiceUrl}/feedback`, feedbackReport.value, {
            headers: {
                'Content-Type': 'application/json'
            },
        })
        .then((response) => {
        // console.log(response)
          showFeedbackForm.value = false;
        })
        .catch((err) => {
          console.error('ERROR', err.message);
        });
    }

    const viewType = (option) => {
        if(option == 'Numerical View') return 'NUMERICAL'
        if(option == 'Categorical View') return 'CATEGORICAL'
        if(option == 'Table View') return 'TABLE'
    }
    
</script>

<style lang="scss">
    .ag-header-cell-label{
        justify-content: center;
    }
</style>